import SingleInputModal from "./SingleInputModal";

export default SingleInputModal;
